export default {
  cards: {
    data: [],
    meta: {}
  },
  card: null,
  tabs: [],
  fields: [],
  availableFields: {
    standard: [],
    form_fields: []
  },
  selectedTab: null,
  selectedField: null,
  previewGroupId: null,
  isDirty: false,
  isLoading: false
}
